"use client";

import {
	Avatar,
	AvatarFallback,
	AvatarImage,
} from "@workspace/ui/components/avatar";
import { resolveAvatarStorageUrl, getUserInitials } from "@workspace/ui/lib/avatars";
import { trpc } from "@/lib/trpc/react";

interface NotificationAvatarProps {
	userId?: string;
	username?: string | null;
	className?: string;
}

export function NotificationAvatar({
	userId,
	username,
	className,
}: NotificationAvatarProps) {
	// Fetch user profile to get avatar
	const { data: profile } = trpc.user.getProfileContent.useQuery(
		{ userId: userId! },
		{
			enabled: !!userId,
			staleTime: 5 * 60 * 1000, // 5 minutes
			select: (data) => ({
				manualAvatar: data?.manual_avatar_url,
				googleAvatar: data?.google_avatar_url,
			}),
		},
	);

	// Prioritize manual avatar over Google avatar
	const avatarUrl = profile?.manualAvatar || profile?.googleAvatar;
	const formattedUrl = avatarUrl ? resolveAvatarStorageUrl(avatarUrl) : null;

	return (
		<Avatar className={className}>
			<AvatarImage src={formattedUrl || undefined} />
			<AvatarFallback>{getUserInitials(username, username)}</AvatarFallback>
		</Avatar>
	);
}
